module.exports = __webpack_public_path__ + "static/media/CM.a72fdb01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/CM.svg
// module id = 2131
// module chunks = 7